import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  USE_AGAIN_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/useItAgainDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [USE_AGAIN_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [USE_AGAIN_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function useItAgainDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
